<template>
  <div class="issue-badge">
    <div class="column--left">
      <img class="issue-badge__icon" :src="getIcon(issue.issueType)">
      <div class="issue-badge__text">

        <div class="issue-badge__text-type">{{getType(issue.issueType)}}</div>

        <div class="issue-badge__issue-status" v-if="issue.serviceProvider != null || userGroup == 'hsg-admins'">
          <transition name="fade">
              <div class="issue-badge__issue-status-selector" v-if="issueSelectorOpen === true">
                <p @click="issueSelectorOpen = false" class="title">Select issue status <span class="chevron"></span></p>

                <p v-if="userGroup == 'hsg-admins' || userGroup == 'multi-site-retailers' || userGroup == 'retailers'" @click="setIssueStatus('unread')"><span class="status-badge unread"></span>Unread</p>
                <p v-if="userGroup == 'hsg-admins' || userGroup == 'multi-site-retailers' || userGroup == 'retailers'" @click="setIssueStatus('resolved-by-retailer')"><span class="status-badge resolved-by-retailer"></span>Resolved By Retailer</p>
                <p v-if="userGroup == 'hsg-admins' || userGroup == 'multi-site-retailers' || userGroup == 'retailers'" @click="setIssueStatus('confirmed')"><span class="status-badge confirmed"></span>Confirmed</p>
                <p v-if="userGroup == 'hsg-admins' || userGroup == 'multi-site-retailers' || userGroup == 'retailers'" @click="setIssueStatus('denied')"><span class="status-badge denied"></span>Denied</p>
                <p v-if="userGroup == 'hsg-admins' || userGroup == 'service-providers'" @click="setIssueStatus('resolution-in-progress')"><span class="status-badge resolution-in-progress"></span>Resolution In Progress</p>
                <p v-if="userGroup == 'hsg-admins' || userGroup == 'service-providers'" @click="setIssueStatus('resolution-awaiting-approval')"><span class="status-badge resolution-awaiting-approval"></span>Resolution Awaiting Approval</p>
                <p v-if="userGroup == 'hsg-admins' || userGroup == 'multi-site-retailers' || userGroup == 'retailers'" @click="setIssueStatus('resolution-accepted')"><span class="status-badge resolution-accepted"></span>Resolution Accepted</p>
                <p v-if="userGroup == 'hsg-admins' || userGroup == 'multi-site-retailers' || userGroup == 'retailers'" @click="setIssueStatus('resolution-denied')"><span class="status-badge resolution-denied"></span>Resolution Denied</p>
              </div>
          </transition>

          <div class="issue-badge__issue-status-text" :class="{'disabled': userGroup == 'multi-site-retailers'}" @click="openIssueSelector()">
            Status: <span class="capitalise"><span class="status-badge" :class="issue.status"></span>{{issue.status}}</span> <span class="chevron" v-if="userGroup != 'multi-site-retailers'"></span>
          </div>
        </div>

        <div class="issue-badge__text-custom-suggestion" v-if="issue.issueType == 'customsuggestion'">
          {{issue.customSuggestionText}}
        </div>
      </div>
    </div>

    <div class="column--right">
      <div class="review-image" :style="{backgroundImage: 'url(' + image + ')'}" @click="showOverlay = true" v-if="issue.s3ImageUrl"></div>
      <div class="review-image placeholder" :style="{backgroundImage: 'url(/static/img/image-placeholder.svg)'}" v-else></div>

      <div class="image-link">
        <p :class="{disabled: !issue.s3ImageUrl}" @click="showOverlay = true">View Image</p>
      </div>

      <transition name="fade" appear>
        <div class="image-overlay" v-if="showOverlay === true" @click="showOverlay = false">
          <div class="image-container" @click="preventBubble($event)">
            <img src="/static/img/icon__close--light.svg" class="close" @click="showOverlay = false">
            <img :src="image" @click="preventBubble($event)">
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import IssuesService from '@/services/IssuesService.js'
  import { EventBus } from '@/EventBus.js'

  export default {
    name: 'issue-badge',

    props: ['issue'],

    data: function () {
      return {
        issueSelectorOpen: false,
        userGroup: null,
        showOverlay: false
      }
    },

    created: function() {
      if(localStorage.getItem('userGroup')) {
        this.userGroup = localStorage.getItem('userGroup');
      }

      this.bindEvents();
    },

    beforeDestroy: function() {
      EventBus.$off('statusUpdateYesClicked' + this.issue.id);
    },

    methods: {
      bindEvents: function() {
        // Listen for File Delete Events
        EventBus.$on('statusUpdateYesClicked' + this.issue.id, (data) => {
          let issueStatus = data.issueStatus;

          IssuesService.replace(this.issue.id, {status: issueStatus})
            .then((res) => {
              this.issue.status = issueStatus;
            })
            .catch((err) => {
              EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
            });
        });
      },

      openIssueSelector: function() {
        if(this.userGroup != 'multi-site-retailers') {
          this.issueSelectorOpen = true;
        }
      },

      setIssueStatus: function(issueStatus) {
        let message = 'Are you sure you want to update the status of this issue to \'' + issueStatus.replace(/-/g, " ") + '\'?';

        let options = [
          {
            optionText:'Yes',
            optionEvent:'statusUpdateYesClicked' + this.issue.id,
            optionData: {
              issueStatus: issueStatus
            }
          },
          {
            optionText:'No',
            optionEvent:'statusUpdateNoClicked',
            optionData: null
          }
        ];

        EventBus.dispatchDialogEvent(message, options);

        this.issueSelectorOpen = false;
      },

      getType: function(issueType) {
        let typeMatrix = {
          smells1: 'No Air Fesheners',
          smells2: 'General Foul Odour',
          smells3: 'Poor Quality Air Fresheners',
          smells4: 'No Open Windows / Poor Ventilation',
          smells5: 'Sanitary / Nappy Units Emitting Foul Odours',
          disability1: 'No Disabled Washroom',
          disability2: 'Washroom Door Too Narrow for Wheelchair Access',
          disability3: 'Hand Dryer at Incorrect Height For Disabled Access',
          disability4: 'Sink / Hand Washing Facilities at Incorrect Height For Disabled Access',
          disability5: 'No Emergency Pull Cord to Alert Assistance',
          lighting1: 'Very Poor Lighting In Cubicle',
          lighting2: 'Very Poor Lighting in Main Washroom',
          heating1: 'No Hot Water',
          heating2: 'Washroom Very Cold',
          babychanging1: 'No Baby Changing Facility At All',
          babychanging2: 'No Baby Changing Facility In Gents Washroom',
          babychanging3: 'No Nappy Changing Table',
          babychanging4: 'Baby Changing Facilities Dirty and Unhygienic',
          babychanging5: 'No Nappy Disposal Unit',
          babychanging6: 'Nappy Disposal Unit Dirty and Smells',
          babychanging7: 'Nappy Disposal Unit Overflowing',
          babychanging8: 'Nappy Disposal Unit Broken',
          babychanging9: 'Nappy Disposal Unit Appears Unhygienic and I Don\'t Want To Touch It',
          cubicles1: 'Cubicle Dirty and/or Smelly',
          cubicles2: 'Faulty Lock',
          cubicles3: 'Cubicle Not Private',
          cubicles4: 'Graffiti in Cubicle',
          cubicles5: 'Cubicle Damaged / Vandalised',
          mirrors1: 'No Mirror',
          mirrors2: 'Broken Mirror',
          mirrors3: 'Mirror Too Small To Be Useful',
          mirrors4: 'Dirty Mirror',
          mirrors5: 'Mirror Sited In Awkward Place',
          decor1: 'Decor Looks Dated',
          decor2: 'Decor Looks Tired and Gives Impression Of Dirty Washroom',
          decor3: 'Pealing Paint / Wallpaper Gives Impression Washroom Is Not Important',
          decor4: 'Sealant Missing Around Sinks and Floor Edge',
          decor5: 'Poor Choice of Colours or Quality Of Overall Finish',
          wallsfloors1: 'Walls / Floors Appear Dirty And Harbour Smells',
          wallsfloors2: 'Floor Wet and Slippery',
          wallsfloors3: 'Condensation / Mould on Walls',
          wallsfloors4: 'Rubbish / Refuse on Floor',
          sanitary1: 'No Sanitary Bin Available',
          sanitary2: 'Sanitary Bin Very Dirty and Smells',
          sanitary3: 'Sanitary Bin Full and Overflowing',
          sanitary4: 'Sanitary Bin Broken',
          sanitary5: 'Sanitary Bin  Appears Unhygienic and I Don\'t Want To Touch It',
          toilet1: 'Toilet Very Dirty and Smells',
          toilet2: 'Toilet Blocked',
          toilet3: 'No Toilet Roll',
          toilet4: 'Toilet Flush Broken',
          toilet5: 'Broken Toilet Seat',
          toilet6: 'No Toilet Roll Dispenser',
          toilet7: 'Toilet / WC has Water Constantly Flowing Into Bowl',
          toilet8: 'No Dual / Reduced Flush Option on Toilet / WC',
          urinals1: 'Urinals Very Dirty and Smell',
          urinals2: 'Urinal(s) Blocked / Overflowing',
          urinals3: 'Urinials Flushing Too Frequently and Wasting Water',
          urinals4: 'Urinals Cracked / Damaged',
          urinals5: 'Urine on Floor Around Urinals',
            bins1: 'No Waste Bins',
            bins2: 'Waste Bins Overflowing',
            bins3: 'Waste Bins Appear Dirty and Harbour Smells',
            bins4: 'Waste Bin Cracked / Damaged',
          handwashing1: 'No Soap Dispensers',
          handwashing2: 'Soap Dispensers Empty',
          handwashing3: 'Soap Dispensers Broken',
          handwashing4: 'Soap Dispensers Dirty and Old',
          handwashing5: 'Bars of Soap Placed on Sink Which I Find Unhygienic',
          sink1: 'No Running Water',
          sink2: 'Sink Blocked',
          sink3: 'Tap Constantly Flowing and Wasting Water',
          sink4: 'Tap(s) Dripping',
          sink5: 'Sink Very Dirty and Smells',
          sink6: 'I Have to Hold Down Tap to Wash Hands At Same Time',
          papertowels1: 'No Paper Towels For Use',
          papertowels2: 'Paper Towel Dispenser Empty',
          papertowels3: 'Paper Towel Dispenser Broken',
          papertowels4: 'Paper Towel Dispenser Dirty and Old',
          papertowels5: 'Poor Quality Paper Towels',
          handdrying1: 'No Hand Dryers',
          handdrying2: 'Hand Dryers Not Working',
          handdrying3: 'Hand Dryers Take Too Long To Dry Hands',
          handdrying4: 'Hand Dryers Dirty and Unhygienic',
          toiletroll1: 'No Toilet Roll',
          toiletroll2: 'No Toilet Roll on Dispenser',
          toiletroll3: 'Toilet Roll Left on Cistern / Floor / Sanitary Bin and Unhygienic',
          toiletroll4: 'Toilet Roll is Poor Quality',
          toiletroll5: 'Toilet Roll in Dispenser but Cannot be Accessed',
          vendingmachines1: 'No Vending Machines',
          vendingmachines2: 'Vending Machine Broken / Jammed',
          vendingmachines3: 'Vending Machine Empty',
          vendingmachines4: 'Vending Machine Doesn\t Offer A Variety of Products',
          vendingmachines5: 'Vending Machine Does Not Accept New Types of Coins',
          suggestions1: 'I\'d Like To See A Changing Places Room',
          suggestions2: 'I\'d Like To See An Odour Control Product in the Urinal',
          suggestions3: 'I\'d Like To See Hand Sanitiser Dispenser in the Washroom',
          suggestions4: 'I\'d Like To See Toilet Seat Sanitisers in the Cubicles',
          suggestions5: 'I\'d Like To See Odour Neutralising Unit Tto Eliminate Odours and Harmful Bacteria',
          suggestions6: 'I\'d Like To See Non-Slip Matting',
          suggestions7: 'I\'d Like To See High Scented Urinal Mats',
          suggestions8: 'I\'d Like To See More Ventilation In Washroom',
          suggestions9: 'I\'d Like To See Anti-Bacterial Door Handles to Eliminate the Spread of Germs',
          customsuggestion: 'I\'d Like To See Something Else',
        }

        return typeMatrix[issueType];
      },

      getIcon: function(issueType) {
        let iconMatrix = {
          smells: '/static/img/area__smell--off.svg',
          disability: '/static/img/area__accessibility--off.svg',
          lighting: '/static/img/area__light--off.svg',
          heating: '/static/img/area__heating--off.svg',
          babychanging: '/static/img/area__baby--off.svg',
          cubicles: '/static/img/area__door--off.svg',
          mirrors: '/static/img/area__mirror--off.svg',
          decor: '/static/img/area__paint--off.svg',
          wallsfloors: '/static/img/area__wall--off.svg',
          sanitary: '/static/img/area__sanitary--off.svg',
          toilet: '/static/img/area__toilet--off.svg',
          urinals: '/static/img/area__urinal--off.svg',
          airfresheners: '/static/img/area__smell--off.svg',
          handwashing: '/static/img/area__soap--off.svg',
          sink: '/static/img/area__sink--off.svg',
          papertowels: '/static/img/area__towel--off.svg',
          handdrying: '/static/img/area__drier--off.svg',
          toiletroll: '/static/img/area__paper--off.svg',
          vendingmachines: '/static/img/area__vending--off.svg',
          suggestions: '/static/img/area__suggestion--off.svg',
          customsuggestion: '/static/img/area__suggestion--off.svg'
        };

        return iconMatrix[issueType.replace(/\d+/g,'')];
      },

      preventBubble: function(e) {
        e.preventDefault();
        e.stopPropagation();
      }
    },

    computed:{
      image: function() {
        return process.env.s3Url + '/img/issues/' + this.issue.s3ImageUrl;
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";
  @import "../../../less/base/project/_variables";

  .issue-badge {
    clear: both;

    .column--left, .column--right {
      float: left;
    }

    .column--left {
      width: 60%;
      padding: 2rem 0;

      .issue-badge__icon {
        width: 5.5rem;
        float: left;
        margin-right: 2rem;
      }

      .issue-badge__text {
        padding-top: 1.2rem;

        .issue-badge__text-type {
          line-height: 1.5rem;
          font-size: 1.5rem;
        }

        .issue-badge__issue-status {
          position: relative;


          .issue-badge__issue-status-text {
            padding-top: 0.5rem;
            line-height: 2rem;
            font-size: 1.25rem;
            cursor: pointer;

            &.disabled {
              cursor: default;
            }

            .capitalise {
              text-transform: capitalize;
              margin-left: 2rem;
            }

            .chevron {
              display: inline-block;
              width: 0.75rem;
              height: 0.75rem;
              margin-left: 0.5rem;
              border-right: 0.125rem solid @dark-text;
              border-bottom: 0.125rem solid @dark-text;
              transform: rotate(45deg) translate(0, -0.3rem);
            }
          }

          .issue-badge__issue-status-selector {
            position: absolute;
            top: 0.25rem;
            left: 7rem;
            z-index: 1;
            width: 27.5rem;
            padding: 3rem 2rem;
            border: 1px solid @brand__grey2;
            border-radius: 1rem;
            background-color: #fff;
            box-shadow: 0 0 14px 3px rgba(0,0,0,0.05);

            .title {
              color: @brand--primary-color;
            }

            .chevron {
              display: inline-block;
              width: 0.75rem;
              height: 0.75rem;
              margin-left: 2.5rem;
              border-right: 0.125rem solid @brand--primary-color;
              border-bottom: 0.125rem solid @brand--primary-color;
              transform: rotate(-135deg) translate(0, -0.3rem);
            }

            p {
              cursor: pointer;
            }
          }
        }

        .issue-badge__text-custom-suggestion {
          white-space: pre-line;
          margin-left: 7.5rem;
        }
      }
    }

    .status-badge {
      display: inline-block;
      width: 2rem;
      height: 2rem;
      margin-right: 1rem;
      border-radius: 50%;
      vertical-align: middle;
    }

    .unread {
      background-color: @brand__grey3;
    }

    .resolved-by-retailer {
      background-color: @brand--secondary-color;
    }

    .confirmed {
      background-color: @accent__red;
    }

    .denied {
      background-color: @brand--primary-color;
    }

    .resolution-in-progress {
      background-color: @accent__amber;
    }

    .resolution-awaiting-approval {
      background-color: @accent__violet;
    }

    .resolution-accepted {
      background-color: @accent__green;
    }

    .resolution-denied {
      background-color: @accent__blue;
    }

    .column--right {
      width: 40%;
      height: 71px;

      .review-image {
        display: inline-block;
        width: 8rem;
        height: 8rem;
        margin: 1rem;
        background-size: cover;
        background-position: center center;
        border-radius: @spacing-unit/10;
        box-shadow: 0 0 5px 3px rgba(0,0,0,0.10);
        vertical-align: middle;

        &:not(.placeholder) {
          cursor: pointer;
        }
      }

      .image-link {
        display: inline-block;

        &::before {
          content: '';
          display: inline-block;
          height: 100%;
          vertical-align: middle;
          margin-right: -0.25em; /* Adjusts for spacing */
        }

        p {
          display: inline-block;
          padding-left: 3rem;
          white-space: nowrap;
          vertical-align: middle;
          color: @brand--secondary-color;
          text-decoration: underline;
          cursor: pointer;

          &.disabled {
            color: @brand__grey3;
            text-decoration: none;
            cursor: default;
          }
        }
      }

      .image-overlay {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: rgba(72, 197, 219, 0.2);

        .image-container {
          display: inline-block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          .close {
            display: inline-block;
            position: absolute;
            top: 30px;
            right: 30px;
            font-size: 5rem;
            color: #fff;
            cursor: pointer;
          }

          img:not(.close) {
            max-width: 80vh;
            max-height: 80vh;
            border: 5px solid #fff;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// IssueBadge.vue?2d914d6e